import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SunSetting02 = function SunSetting02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 16.5H2M20 20H4m8-17v2m-8 8H2m4.3141-5.6859L4.9 5.9m12.7856 1.4142L19.0998 5.9M22 13h-2M7 13c0-2.7614 2.2386-5 5-5s5 2.2386 5 5"
    })
  }));
};
export default SunSetting02;